/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyAppleReceiptDto
 */
export interface VerifyAppleReceiptDto {
    /**
     * 
     * @type {string}
     * @memberof VerifyAppleReceiptDto
     */
    transactionId: string;
}

export function VerifyAppleReceiptDtoFromJSON(json: any): VerifyAppleReceiptDto {
    return VerifyAppleReceiptDtoFromJSONTyped(json, false);
}

export function VerifyAppleReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyAppleReceiptDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionId': json['transactionId'],
    };
}

export function VerifyAppleReceiptDtoToJSON(value?: VerifyAppleReceiptDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionId': value.transactionId,
    };
}

